import InputField from "@/components/form/InputField";
import * as Yup from "yup";

export const textAreaValidationSchema = {
  options: Yup.object()
    .nullable()
    .shape({
      textarea: Yup.object()
        .nullable()
        .shape({
          rows: Yup.number()
            .nullable()
            .min(1, "Must have at least 1 row")
            .max(50, "Cannot exceed 50 rows"),
        }),
    }),
};

export default function TextAreaDisplayOptions() {
  return (
    <div>
      <InputField name="options.textarea.rows" label="Rows" type="number" />
    </div>
  );
}
